import React, { useState } from "react";
import "./Solutions.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const faqData = [
  {
    question: "What services do you offer?",
    answer:
      "We provide AI automation, SaaS development, web & mobile apps, marketing solutions, and enterprise systems.",
  },
  {
    question: "What is your pricing model?",
    answer:
      "Our pricing depends on project scope. We offer fixed pricing and monthly retainers.",
  },
  {
    question: "How long does a project take?",
    answer:
      "Projects usually take 2-8 weeks depending on complexity and requirements.",
  },
  {
    question: "Do you provide support after launch?",
    answer:
      "Yes, we offer ongoing support, maintenance, and scaling services.",
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0); // first open

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="backdiv">
      <h2 className="main-title">Frequently Asked Questions</h2>

      <div className="faq-container">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggle(index)}
          >
            {/* QUESTION */}
            <div className="faq-question">
              <h3>{item.question}</h3>

              <motion.span
                animate={{ rotate: activeIndex === index ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <FaChevronDown />
              </motion.span>
            </div>

            {/* ANSWER */}
            <AnimatePresence>
              {activeIndex === index && (
                <motion.div
                  className="faq-answer"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35 }}
                >
                  <p className="main-text-white">{item.answer}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;